<template>
    <div class="modal" @click.self="$emit('close')">
        <div class="modal-close" @click="$emit('close')"></div>
        <div class="modal-container">
            <iframe
                :src="embedUrl"
                :width="videoWidth"
                :height="videoHeight"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
            ></iframe>
        </div>
    </div>

</template>

<script>
export default {
    name : "ModalVideo",
    props : ["video"],
    data() {
        return {
            videoWidth: 1280,
            videoHeight : 720
        }
    },
    computed : {
        videoId() {
            if (!this.video) return "";
            const match = this.video.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^#&?/]+)/);
            return match ? match[1] : "";
        },
        embedUrl() {
            return this.videoId ? `https://www.youtube.com/embed/${this.videoId}?autoplay=1` : "";
        }
    },
    mounted() {
        if(window.innerWidth < 1600) {
            this.videoWidth = 640;
            this.videoHeight = 360;
        }
        else if(window.innerWidth < 768) {
            this.videoWidth = 320;
            this.videoHeight = 180;
        }else {
             this.videoWidth = 1280;
            this.videoHeight = 720;
        }
    }
}
</script>

<style scoped lang="scss">

</style>
